<template>
    <div class="position">
        <NoData v-if="position.length<=0" :isTrade="isTrade"></NoData>
        <ul v-else>
            <li v-for="item in position" @click="goPositionChart(item.SName.uiCodeID,item.ID)">
                <div class="itemTit">
                    <div class="leftCon"><span>{{item.SName.szShortName}}</span><p>#{{item.ID}}</p></div>
                    <div class="rightCon">
                        <div class="item" v-if="item.StopLoss && Number(item.StopLoss) != 0"><img src="@/assets/images/template/icon_pic_stoploss.png"/><span>{{$t('trade.products.stopLoss')}}</span></div>
                        <div class="item" v-if="item.TakeProfit && Number(item.TakeProfit) !=0 "><img src="@/assets/images/template/icon_pic_tar.png"/><span>{{$t('trade.products.stopProfit')}}</span></div>
                    </div>
                </div>
                <div class="itemCon">
                    <div class="leftCon">
                        <div class="itemList">
                            <div class="item"><em :class="cutover(tradeUtil.OrderDirection[item.Direction])">{{tradeUtil.OrderDirection[item.Direction]}}</em><p>{{item.Volume}}</p></div>
                            <div class="item width"><span>{{$t('success.openingPrice')}}</span><p>{{item.OpenPrice}}</p></div>
                        </div>
                        <!-- <div class="itemList">
                            <div class="item"><time>{{item.OpenTime|time}}</time></div>
                            <div class="item width"><span>{{$t('success.executePrice')}}</span><p>{{item.Direction==1?quote.symbolTickMap[item.SName.szShortName].ask:quote.symbolTickMap[item.SName.szShortName].bid}}</p></div>
                        </div> -->
                    </div>
                    <div class="rightCon">
                        <!--买-->
                        <!-- <div class="item" v-if="item.Direction == 1"> -->
                            <!--直接货币：(买跌价-买涨价)*合约单位*手数-->
                            <!-- <span v-if="item.symbolData.stockType == 0" :class="buyGain(util.accAdd(((quote.symbolTickMap[item.SName.szShortName].ask - item.OpenPrice)*item.symbolData.contractSize*item.Volume),item.Swap))"><em>+</em>{{util.accAdd(((quote.symbolTickMap[item.SName.szShortName].ask - item.OpenPrice)*item.symbolData.contractSize*item.Volume),item.Swap).toFixed(2)}}</span> -->
                            <!--间接货币：(买跌价-买涨价)*合约单位*手数/美元相对货币买跌即时汇率-->
                            <!-- <span v-if="item.symbolData.stockType == 1" :class="buyGain(util.accAdd(((quote.symbolTickMap[item.SName.szShortName].ask - item.OpenPrice)*item.symbolData.contractSize*item.Volume/quote.symbolTickMap[item.SName.szShortName].ask),item.Swap))"><em>+</em>{{util.accAdd(((quote.symbolTickMap[item.SName.szShortName].ask - item.OpenPrice)*item.symbolData.contractSize*item.Volume/quote.symbolTickMap[item.SName.szShortName].ask),item.Swap).toFixed(2)}}</span> -->
                            <!--交叉货币直接货币:(买跌价-买涨价)*合约单位*手数*该相对货币对兑美元买跌方向的即时汇率-->
                            <!-- <span v-if="item.symbolData.stockType == 2" :class="buyGain(util.accAdd(((quote.symbolTickMap[item.SName.szShortName].ask - item.OpenPrice)*item.symbolData.contractSize*item.Volume*quote.symbolTickMap[item.symbolData.relateSymbol].ask),item.Swap))"><em>+</em>{{util.accAdd(((quote.symbolTickMap[item.SName.szShortName].ask - item.OpenPrice)*item.symbolData.contractSize*item.Volume*quote.symbolTickMap[item.symbolData.relateSymbol].ask),item.Swap).toFixed(2)}}</span> -->
                            <!--交叉货币间接货币:(买跌价-买涨价)*合约单位*手数/该相对货币对兑美元买跌方向的即时汇率-->
                            <!-- <span v-if="item.symbolData.stockType == 3" :class="buyGain(util.accAdd(((quote.symbolTickMap[item.SName.szShortName].ask - item.OpenPrice)*item.symbolData.contractSize*item.Volume/quote.symbolTickMap[item.symbolData.relateSymbol].ask),item.Swap))"><em>+</em>{{util.accAdd(((quote.symbolTickMap[item.SName.szShortName].ask - item.OpenPrice)*item.symbolData.contractSize*item.Volume/quote.symbolTickMap[item.symbolData.relateSymbol].ask),item.Swap).toFixed(2)}}</span> -->
                        <!-- </div> -->
                        <!--卖-->
                        <!-- <div class="item" v-else-if="item.Direction == 2"> -->
                            <!--直接货币：(买跌价-买涨价)*合约单位*手数-->
                            <!-- <span v-if="item.symbolData.stockType == 0" :class="sellGain(util.accAdd(((item.OpenPrice - quote.symbolTickMap[item.SName.szShortName].bid)*item.symbolData.contractSize*item.Volume),item.Swap))"><em>+</em>{{util.accAdd(((item.OpenPrice - quote.symbolTickMap[item.SName.szShortName].bid)*item.symbolData.contractSize*item.Volume),item.Swap).toFixed(2)}}</span> -->
                            <!--间接货币：(买跌价-买涨价)*合约单位*手数/美元相对货币买跌即时汇率-->
                            <!-- <span v-if="item.symbolData.stockType == 1" :class="sellGain(util.accAdd(((item.OpenPrice - quote.symbolTickMap[item.SName.szShortName].bid)*item.symbolData.contractSize*item.Volume/quote.symbolTickMap[item.SName.szShortName].bid),item.Swap))"><em>+</em>{{util.accAdd(((item.OpenPrice - quote.symbolTickMap[item.SName.szShortName].bid)*item.symbolData.contractSize*item.Volume/quote.symbolTickMap[item.SName.szShortName].bid),item.Swap).toFixed(2)}}</span> -->
                            <!--交叉货币直接货币:(买跌价-买涨价)*合约单位*手数*该相对货币对兑美元买跌方向的即时汇率-->
                            <!-- <span v-if="item.symbolData.stockType == 2" :class="sellGain(util.accAdd(((item.OpenPrice - quote.symbolTickMap[item.SName.szShortName].bid)*item.symbolData.contractSize*item.Volume*quote.symbolTickMap[item.symbolData.relateSymbol].bid),item.Swap))"><em>+</em>{{util.accAdd(((item.OpenPrice - quote.symbolTickMap[item.SName.szShortName].bid)*item.symbolData.contractSize*item.Volume*quote.symbolTickMap[item.symbolData.relateSymbol].bid),item.Swap).toFixed(2)}}</span> -->
                            <!--交叉货币间接货币:(买跌价-买涨价)*合约单位*手数/该相对货币对兑美元买跌方向的即时汇率-->
                            <!-- <span v-if="item.symbolData.stockType == 3" :class="sellGain(util.accAdd(((item.OpenPrice - quote.symbolTickMap[item.SName.szShortName].bid)*item.symbolData.contractSize*item.Volume/quote.symbolTickMap[item.symbolData.relateSymbol].bid),item.Swap))"><em>+</em>{{util.accAdd(((item.OpenPrice - quote.symbolTickMap[item.SName.szShortName].bid)*item.symbolData.contractSize*item.Volume/quote.symbolTickMap[item.symbolData.relateSymbol].bid),item.Swap).toFixed(2)}}</span> -->
                        <!-- </div> -->
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import NoData from '@/view/module/NoData.vue'
    import TradeUtil from '@/utils/tradeUtil'
    import Util from '@/utils/tradeDataUtil'
    export default {
        filters: {
            time(longTime) {
                return Util.formatDate(longTime,"yyyy-MM-dd hh:mm:ss");
            }
        },
        components:{NoData},
        computed: {
            ...mapState(['tradeData', 'quote']),
            position: {
                get() {
                    console.log('Position.vue', this.tradeData.position)
                    //深度拷贝并复制持仓列表数据
                    return this.tradeData.position;
                },
            }
        },      
        data() {
            return {
                util:Util,
                tradeUtil: TradeUtil,
                isShow:false,
                isTrade:true
            }
        },
        watch: {
            tradeData(newValue, oldValue) {
                console.log('newValue', newValue)
            }        
        },
        methods:{
            goPositionChart(codeId,id) {
                this.$bus.$emit('loading', false);
                this.$router.push({path: '/home/positionChart',query: {id: codeId,positionId:id}})
            },
            cutover:function(obj){
                let val;
                if (obj==this.$t('trade.products.buy')){
                    val="buy"
                }else if(obj==this.$t('trade.products.sell')){
                    val="sell"
                }
                return val;
            },
            buyGain:function(obj){
                let val;
                if (obj>0){
                    val="rise";
                }else if(obj==0){
                    val="level";
                }else {
                    val="fall";
                }
                return val;
            },
            sellGain:function(obj){
                let val;
                if (obj>0){
                    val="rise";
                }else if(obj==0){
                    val="level";
                }else {
                    val="fall";
                }
                return val;
            },
        },
    }
</script>
